export const TMG = {
  '500_message_bundle': {
    qa: 'price_1HjzxIAZzIXwKqVJ9qLjeZ23',
    prod: 'price_1Hj7qdAZzIXwKqVJEKJJCU9z',
  },
  'number_bundle': {
    qa: 'price_1Ku63mFOVxqXc60A3xcfBLPt',
    prod: 'price_1Kim5EBoxEBjoujWzNLOCkYc',
  },
};

export const TIC = {
  number_bundle: {
    qa: 'price_1M2IVZFOVxqXc60AJihqZ0cZ',
    prod: 'price_1LxBKDBoxEBjoujWM7FCCgV8',
  },
};
